import { ROW_CHECK_OPTIONS } from "~/components/Table/TableRow/DefaultTableRow/options";
import s from "~/components/Table/TableRow/DefaultTableRow/TableRow.less";
import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { nanoid } from "nanoid";
import { IconMimeType } from "~/libs/resolveMemeType";
import Violation from "~/components/Icons/icon-violations";
import Warning from "~/components/Icons/alert-square";
import IconInfo from "~/components/Icons/info";
import Button from "~/shared/ui/Fields/Button";
import PersonalDataFile from "~/components/Table/TableRow/DefaultTableRow/items/PersonalDataFile";
import InfoSystemPositions from "~/components/Table/TableRow/DefaultTableRow/items/InfoSystemPositions";

export const RowHandlerByOptionNameFirstLayer = ({
  type,
  optionName,
  item,
}) => {
  const { t } = useTranslation();

  switch (type) {
    case "users":
      switch (optionName) {
        case ROW_CHECK_OPTIONS.role:
        case ROW_CHECK_OPTIONS.unit:
        case ROW_CHECK_OPTIONS.period:
        case ROW_CHECK_OPTIONS.status:
          return (
            <span className={s.cont}>{t(`${type}.${item[optionName]}`)}</span>
          );
      }
      break;
  }
};

export const RowHandlerByOptionNameSecondLayer = ({
  type,
  optionName,
  item,
  copyToClipboard,
  textAreaRef,
  rowValuesDecorator,
}) => {
  switch (type) {
    case "personal_data":
      switch (optionName) {
        case "personalDataTemplate":
          return <PersonalDataFile item={item} IconMimeType={IconMimeType} />;
      }
      break;
    case "information_system":
      switch (optionName) {
        case "Positions":
          return <InfoSystemPositions item={item} key={item.id} />;
      }
      break;
    case "announcement":
      switch (optionName) {
        case "Documents":
          return <DocumentsHandler item={item} />;
        case "title":
          return <TitleHandler item={item} optionName={optionName} />;
        case "importance":
          return <ImportanceHandler item={item} />;
      }
      break;

    case "documents.table":
      switch (optionName) {
        case "Files":
          return <DocumentsHandler item={item} />;
        case "description":
          return <HiddenInfoHandler text={item.description} />;
        case "importance":
          return <ImportanceHandler item={item} />;
      }
      break;

    case "logs":
      switch (optionName) {
        case "customs":
          if (textAreaRef && copyToClipboard) {
            return (
              <LogsHandler
                item={item}
                optionName={optionName}
                textAreaRef={textAreaRef}
                copyToClipboard={copyToClipboard}
              />
            );
          } else return item[optionName];
      }
      break;

    case "users":
      switch (optionName) {
        case ROW_CHECK_OPTIONS.role:
        case ROW_CHECK_OPTIONS.unit:
        case ROW_CHECK_OPTIONS.period:
        case ROW_CHECK_OPTIONS.status:
          return undefined;
      }
      break;
  }

  if (!!rowValuesDecorator) {
    return rowValuesDecorator(item[optionName], optionName, item);
  }

  return item[optionName];
};

const ShowFilesLinksField = ({ file }) => {
  return (
    <span key={nanoid()} className={s.cont}>
      {!!file?.link && (
        <a
          href={file.link}
          download
          onClick={(e) => e.stopPropagation()}
          target="_blank"
          placeholder={file.name}
        >
          {IconMimeType(file)}
        </a>
      )}
    </span>
  );
};

const ImportanceHandler = ({ item }) => {
  return item["importance"] === "urgent" ? (
    <Violation fill={"#db0505"} color={"#fff"} width={"22"} height={"22"} />
  ) : (
    <span className={s.svgImg}>
      {" "}
      <Warning />
    </span>
  );
};

const TitleHandler = ({ item, optionName }) => {
  return (
    <>
      <div className={s.elementEffect}>{item[optionName]}</div>

      <div className={s.hoverEffect}>
        <IconInfo />
        <span
          className={s.countText}
          dangerouslySetInnerHTML={{ __html: item.text }}
        />{" "}
      </div>
    </>
  );
};

const HiddenInfoHandler = (item) => {
  return (
    <div className={s.hoverEffect}>
      <IconInfo />
      <span
        className={s.countText}
        dangerouslySetInnerHTML={{ __html: item.text }}
      />{" "}
    </div>
  );
};

const DocumentsHandler = ({ item }) => {
  return (item.Documents || item.Files).map((el) => (
    <Fragment key={el.id}>
      <ShowFilesLinksField file={el} />
    </Fragment>
  ));
};

const LogsHandler = ({ item, optionName, copyToClipboard, textAreaRef }) => {
  return (
    <>
      <Button
        small
        txtBtn={"Скопировать"}
        onClick={copyToClipboard}
        disabled={item[optionName] === "null"}
        customClassName={s.wide_btn}
      >
        {/*<Default /> */}
      </Button>

      <form>
        <textarea
          ref={textAreaRef}
          value={`${item[optionName]}`}
          className={s.dontActive}
        />
      </form>
    </>
  );
};
